import moment, { Moment } from 'moment';

export enum DateFormat {
  DATE = 'DD-MM-YYYY',
  DATE_2 = 'DD/MM/YYYY',
  DATE_3 = 'D MMMM YYYY',
  DATE_4 = 'YYYY-MM-DD',
  DATE_TIME = 'DD-MM-YYYY HH:mm',
  DATE_TIME_2 = 'DD-MM-YYYY HH:mm:ss',
  DATE_TIME_3 = 'D MMMM, YYYY HH:mm',
}

export const convertDateToUnix = (date: Moment) => {
  const unixTime = date.unix();
  return unixTime;
};

export const convertUnixToDate = (value: number, format: DateFormat) => {
  const date = moment(value * 1000);
  const readableTime = date.format(format);
  return readableTime;
};
